import React from 'react';
import { css } from '@emotion/core';

import { scrollPromoBodyIntoView } from 'client/utils/scroll';
import ActionButton from 'client/components/Result/Actions/ActionButton';

function SecondaryButton({ text, IconComponent = null, onClick = () => {}, ...restProps }) {
    function handleClick() {
        scrollPromoBodyIntoView();
        onClick();
    }

    return (
        <ActionButton
            text={
                <>
                    {Boolean(IconComponent) && <IconComponent css={iconStyle} />}
                    {text}
                </>
            }
            onClick={handleClick}
            {...restProps}
        />
    );
}

export default SecondaryButton;

const iconStyle = css`
    margin-right: 4px;
`;
